import { useTranslation } from 'react-i18next';
import { config } from '../../config';
import { resources } from '../../resources/resources';

export default function GdprPage() {
  const { t: translate } = useTranslation();

  return (
    <iframe
      title={translate(resources.preferences.rights.portability.gDPR)}
      height="1080"
      src={config.gdprUrl}
    ></iframe>
  );
}
